import { render, staticRenderFns } from "./veelgestelde-vragen.vue?vue&type=template&id=84d5a0cc"
import script from "./veelgestelde-vragen.vue?vue&type=script&lang=js"
export * from "./veelgestelde-vragen.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports